import { useCallback, useEffect, useState } from "react";
import clinicAPI from "../../../services/clinicApi";
import {
  HubListGroup,
  HubRow,
  HubSegment,
} from "../AdminPortal/HubPwa";
import { EmptyState, SkeletonCard } from "../../ui";
import { personDisplayName } from "../../../utils/clientAppUtils";
import GroupLeaderboardChart from "./GroupLeaderboardChart";
import useClubPortalBranding from "../../../hooks/useClubPortalBranding";

const PERIODS = [
  { id: "month", label: "Месяц" },
  { id: "quarter", label: "90 дней" },
];

function rankBadgeTone(rank, pct) {
  if (rank === 1) return "ok";
  if (rank <= 3) return "accent";
  if (pct != null && pct < 50) return "warn";
  return "muted";
}

export default function GroupLeaderboardPanel({ groupId }) {
  const [period, setPeriod] = useState("month");
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const { theme } = useClubPortalBranding("aa", null, false);

  const load = useCallback(async () => {
    if (!groupId) return;
    setLoading(true);
    try {
      const res = await clinicAPI.getGroupLeaderboard(groupId, { period });
      setData(res);
    } catch {
      setData(null);
    } finally {
      setLoading(false);
    }
  }, [groupId, period]);

  useEffect(() => {
    load();
  }, [load]);

  if (!groupId) return null;
  if (loading) return <SkeletonCard />;

  const rows = data?.leaderboard || [];

  if (!rows.length) {
    return (
      <>
        <HubSegment tabs={PERIODS} active={period} onChange={setPeriod} />
        <EmptyState
          title="Рейтинг пока пуст"
          description="Отметьте посещаемость на прошедших занятиях — таблица заполнится автоматически"
        />
      </>
    );
  }

  return (
    <>
      <HubSegment tabs={PERIODS} active={period} onChange={setPeriod} />
      <p style={{ margin: "0 0 12px", fontSize: 13, color: "var(--aa-muted)" }}>
        {data.period_label} · в рейтинге {rows.length} спортсменов
      </p>
      <GroupLeaderboardChart
        rows={rows}
        accent={theme.accent}
        title="Рейтинг по явке"
      />
      <HubListGroup>
        {rows.map((row) => (
          <HubRow
            key={row.patient_id}
            title={`${row.rank}. ${personDisplayName(row.full_name) || row.full_name}`}
            meta={`${row.present} посещений · ${row.marked} отмечено${
              row.streak >= 2 ? ` · серия ${row.streak}` : ""
            }`}
            badge={row.pct != null ? `${row.pct}%` : "—"}
            badgeTone={rankBadgeTone(row.rank, row.pct)}
            progress={row.pct}
          />
        ))}
      </HubListGroup>
    </>
  );
}
